import React, { useRef, useState } from "react";
import { GripVertical, ImagePlus, Star, Trash2, UploadCloud } from "lucide-react";
import "./ImageDropzone.css";

const acceptedTypes = new Set(["image/jpeg", "image/png", "image/webp"]);

export const existingImages = (items = []) => items.map((item, index) => {
  const image = typeof item === "string" ? { url: item } : item;
  if (!image?.url) return null;
  return {
    id: `existing-${index}-${image.path || image.url}`,
    url: image.url,
    path: image.path || "",
    alt: image.alt || "",
    orden: image.orden ?? index,
    file: null,
  };
}).filter(Boolean);

export default function ImageDropzone({ items, onChange, maxFiles = 8, label = "Imágenes", onError }) {
  const inputRef = useRef(null);
  const dragIndex = useRef(null);
  const [active, setActive] = useState(false);

  const addFiles = (list) => {
    const incoming = [...list];
    const valid = incoming.filter((file) => acceptedTypes.has(file.type) && file.size <= 5 * 1024 * 1024);
    if (valid.length !== incoming.length) onError?.("Usa imágenes JPG, PNG o WebP de máximo 5 MB.");
    const remaining = Math.max(0, maxFiles - items.length);
    if (valid.length > remaining) onError?.(`Puedes utilizar un máximo de ${maxFiles} imágenes.`);
    const next = valid.slice(0, remaining).map((file) => ({ id: `${Date.now()}-${Math.random()}`, url: URL.createObjectURL(file), path: "", file }));
    if (next.length) onChange([...items, ...next]);
  };

  const drop = (event) => { event.preventDefault(); setActive(false); addFiles(event.dataTransfer.files); };
  const reorder = (target) => {
    const source = dragIndex.current;
    if (source === null || source === target) return;
    const next = [...items]; const [item] = next.splice(source, 1); next.splice(target, 0, item); onChange(next); dragIndex.current = null;
  };

  return <div className="image-uploader">
    <div className="image-uploader__head"><strong>{label}</strong><span>{items.length}/{maxFiles} · La primera imagen será la portada</span></div>
    <button type="button" className={`image-dropzone ${active ? "active" : ""}`} onClick={() => inputRef.current?.click()} onDragOver={(e) => { e.preventDefault(); setActive(true); }} onDragLeave={() => setActive(false)} onDrop={drop}>
      <UploadCloud /><strong>Arrastra tus imágenes aquí</strong><span>o presiona para seleccionar · JPG, PNG o WebP · máximo 5 MB</span>
    </button>
    <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp" multiple hidden onChange={(e) => { addFiles(e.target.files); e.target.value = ""; }} />
    {items.length ? <div className="image-preview-list">{items.map((item, index) => <article draggable onDragStart={() => { dragIndex.current = index; }} onDragOver={(e) => e.preventDefault()} onDrop={() => reorder(index)} key={item.id}>
      <img src={item.url} alt={`Vista previa ${index + 1}`} />
      <span className="image-grip"><GripVertical /></span>
      {index === 0 && <b><Star />Portada</b>}
      <button type="button" onClick={() => onChange(items.filter((candidate) => candidate.id !== item.id))} aria-label="Eliminar imagen"><Trash2 /></button>
    </article>)}</div> : <div className="image-uploader__empty"><ImagePlus />Todavía no agregaste imágenes.</div>}
  </div>;
}
